module.exports = __webpack_public_path__ + "media/images/emp-select-280cc7c9.png";